import { Formik, Form } from "formik";
import FormWrapper from "components/FormWrapper";
import ResetAndSubmit from "components/ResetAndSubmit";
import * as Yup from "yup";
import WebsiteTemplate from "components/NewCards/WebsiteTemplate";
import { useEffect, useState } from "react";
import { Img } from "components";
import axios from "axios";
import { API_CONSTANT_ONBOARDING } from "utils";

const validationSchema = Yup.object({
  template: Yup.object()
    .shape({
      MASTER_TEMPLATE_ID: Yup.string().required(),
      TEMPLATE_NAME: Yup.string().required(),
    })
    .required("Please select at least one template."),
});

interface Props {
  handleNavigate?: any;
  resetFormData?: any;
  disableForm?: any;
}

const Template = ({ handleNavigate, resetFormData, disableForm }: Props) => {
  const [templateList, setTemplateList] = useState([]);
  const [loader, setLoader] = useState(false);

  const loadInitialData = () => {
    const saved = sessionStorage.getItem("template");
    return saved ? JSON.parse(saved) : null;
  };

  const fetchData = async () => {
    try {
      setLoader(true);
      const response = await axios.get(
        `${API_CONSTANT_ONBOARDING}/master/masterTemplate/list`
      );
      setTemplateList(
        response?.data?.data?.map((item) => ({
          ...item,
          thumbnail: `https://storage.soomuch.ai/data-soomuch/MASTER/TEMPLATE/${item?.TEMPLATE_NAME}/${item?.TEMPLATE_NAME}_IMAGES/thumbnail.png`,
          url: `https://storage.soomuch.ai/data-soomuch/MASTER/TEMPLATE/${item?.TEMPLATE_NAME}/${item?.TEMPLATE_NAME}_IMAGES/screenshot.png`,
        })) || []
      );
    } catch (err) {
      console.error("Error fetching templates:", err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return !loader ? (
    <Formik
      initialValues={{
        filter: "",
        searchTerm: "",
        template: loadInitialData(),
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => {
        console.log("Form submitted with values:", values);
        // Save selected template to sessionStorage
        sessionStorage.setItem("template", JSON.stringify(values.template));
        // Navigate to next step
        if (handleNavigate) {
          handleNavigate();
        }
      }}
    >
      {({
        values,
        handleSubmit,
        resetForm,
        errors,
        setFieldValue,
        touched,
      }) => {
        // console.log("Form values:", values);
        // console.log("Form errors:", errors);

        const handleRadioChange = (value) => {
          setFieldValue("template", value);
        };

        const isTemplateSelected =
          values.template &&
          values.template.MASTER_TEMPLATE_ID &&
          values.template.TEMPLATE_NAME;

        return (
          <FormWrapper
            childern={
              <Form onSubmit={handleSubmit}>
                <div className="grid grid-cols-4 gap-6 min-h-[60vh] max-h-[60vh] overflow-auto px-2">
                  {templateList.map((template, index) => (
                    <WebsiteTemplate
                      key={template?.TEMPLATE_NAME}
                      element={template}
                      selectedValue={values.template}
                      onChange={handleRadioChange}
                    />
                  ))}
                </div>
                {!disableForm && (
                  <ResetAndSubmit
                    submitToolTip={
                      !isTemplateSelected ? "Please select one template" : ""
                    }
                    isError={!isTemplateSelected}
                    resetForm={() => {
                      resetForm();
                      if (resetFormData) {
                        resetFormData();
                      }
                    }}
                  />
                )}
                {/* Display validation error */}
                {errors.template && touched.template && (
                  <div className="text-red-500 text-sm mt-2">
                    {(errors as any).template}
                  </div>
                )}
              </Form>
            }
          />
        );
      }}
    </Formik>
  ) : (
    <div className="flex justify-center">
      <Img src={"/images/loader.gif"} className="h-20" />
    </div>
  );
};

export default Template;
